// extracted by mini-css-extract-plugin
export default {"main":"CatalogCard_main__A5WFL"};